export interface ProductPrice {
  id: string;
  priceListId: string;
  productId: string;
  productKey: string;
  productDescription: string;
  currencyId: string;
  currencyCode: string;
  currencySymbol: string;
  priceBandId: string;
  lowerQuantity: number;
  upperQuantity: number;
  priceBandDescription: string;
  price: number;
  splitPrice: number;
  recommendedRetailPrice: number;
  priceListCurrency: string;
}
